import OrderDetails from "../../components/createSecondaryOrder/OrderDetails";
import { safeStringify, truncateToTwoDecimals } from "../../components/dms_common/DmsUtils";
import { getLob } from "../../services/authenticationService";
import { getConfigData } from "../../services/configurationService";
import { insertDataIntoLocalDB } from "../../services/dbService";
import { generateBatchInvoicePdf, generateInvoicePdf, generateInvoicePdfFileKey, getOutletApprovalData,generateBulkInvoicePdfCokeNp, getSkuReplacement, AggregatedStockData } from "../../services/manageOrderService";
import { sendSlackAlert, SlackChannel } from "../../services/slackService";
import { createCartProductFromCatalogue, getCurrentDateTimeFormat } from "../createSecondaryOrder/CreateSecondaryOrderService";
import { Cart, Catalogue } from "../createSecondaryOrder/models";
import { checkIfStockExceeded } from "./ViewOrderConfig";
import { FulfillmentInfo, viewManageOrderRowsData } from "./ViewOrderType";

export const keysToKeep = [
  "beat",
  "billAmount",
  "netAmount",
  "totalAmount",
  "finalOrderInfo",
  "freeItemInfo",
  "creationTime",
  "referenceNumber",
  "type",
  "source",
  "orderDetails",
  "outletCode",
  "loginId",
  "extendedAttributes",
  "submissionTime",
  "status",
  "remarks",
  "referenceOrderNumber",
]

export const keysToKeepOD = [
  "initialNormalizedQuantity",
  "batchCode",
  "casePrice",
  "caseQuantity",
  "creditQuantity",
  "extendedAttributes",
  "otherUnitPrice",
  "otherUnitQuantity",
  "pieceQuantity",
  "price",
  "skuCode",
  "supplier",
  "source",
  "type",
  "siteId",
  "lineCount",
  "status"
]

// helper function to pick only allowed keys
const pickKeys = (obj: any, keys: string[]) =>
  keys.reduce((acc, key) => {
    if (obj.hasOwnProperty(key)) {
      acc[key] = obj[key];
    }
    return acc;
  }, {} as any);

// main function
export const transformValidateResponse = (validateResponse: any) => {
  if (!validateResponse) return null;

  // pick only header keys
  const filteredHeader = pickKeys(validateResponse, keysToKeep);

  // pick only orderDetails keys
  if (filteredHeader.orderDetails && Array.isArray(filteredHeader.orderDetails)) {
    filteredHeader.orderDetails = filteredHeader.orderDetails.map((od: any) =>
      pickKeys(od, keysToKeepOD)
    );
  }

  return filteredHeader;
};

export const mergeProductsWithOmsRows = (
  addMorePrimaryOmsRowsData: any[],
  productsMap: Record<string, any>,
  defaultSiteOms: string,
  supplier: string,
  warehouse:string,
) => {
  Object.entries(productsMap).forEach(([batchCode, product]) => {
    // let matched = false;

    // for (let row of addMorePrimaryOmsRowsData) {
    //   if (row.batchCode === batchCode && row.siteAllSku === defaultSiteOms) {
    //     // Add quantities to the first matching row
    //     row.caseQuantity = (row.caseQuantity || 0) + (product.caseQuantity || 0);
    //     row.pieceQuantity = (row.pieceQuantity || 0) + (product.pieceQuantity || 0);
    //     row.otherUnitQuantity = (row.otherUnitQuantity || 0) + (product.otherUnitQuantity || 0);
    //     matched = true;
    //     break; // stop after first match
    //   }
    // }

    // if (!matched) {
      // Create a new row if no match found
      addMorePrimaryOmsRowsData.push({
        id:crypto.randomUUID(),
        batchCode,
        skuCode: product.skuCode,
        casePrice: product.casePrice || 0,
        caseQuantity: product.caseQuantity || 0,
        otherUnitPrice: product.otherUnitPrice || 0,
        otherUnitQuantity: product.otherUnitQuantity || 0,
        pieceQuantity: product.pieceQuantity || 0,
        price: product.price || 0,
        siteAllSku: defaultSiteOms,
        warehouseAllSku: warehouse,
        discountInfo: null,
        source: "DMS",
        supplier: supplier,
        type: "normal"
      });
    // }
  });

  return addMorePrimaryOmsRowsData;
};



export const prepareSaveChangesReqBody =  (filterRowsForPayload: any[], supplier: string,loginid: string,outletCode:string,oldTlc:number, flagToConfirmOriginalOrder: boolean = false) => {
  let sendAmount = 0;

  const firstWarehouse = filterRowsForPayload[0]?.warehouseAllSku ?? "";
  const fixSite = filterRowsForPayload[0]?.siteAllSku ?? "";

  const quantityNodes: {
    batchCode: string;
    caseQuantity: number;
    otherUnitQuantity: number;
    pieceQuantity: number;
  }[] = [];

  const orderDetailsNodes = filterRowsForPayload.map((row) => {
    sendAmount +=
      (row?.caseQuantity ?? 0) * Number(row?.casePrice ?? 0) +
      (row?.otherUnitQuantity ?? 0) * Number(row?.otherUnitPrice ?? 0) +
      (row?.pieceQuantity ?? 0) * Number(row?.price ?? 0);

    quantityNodes.push({
      batchCode: row.batchCode,
      caseQuantity: row.caseQuantity ?? 0,
      otherUnitQuantity: row.otherUnitQuantity ?? 0,
      pieceQuantity: row.pieceQuantity ?? 0,
    });

    return {
      batchCode: row.batchCode,
      skuCode: row.batchCode,
      status: flagToConfirmOriginalOrder ? "CONFIRMED" : "PENDING",
      lineCount: row?.lineCount,
      casePrice: Number(row?.casePrice ?? 0),
      caseQuantity: row.caseQuantity ?? 0,
      otherUnitPrice: Number(row?.otherUnitPrice ?? 0),
      otherUnitQuantity: row.otherUnitQuantity ?? 0,
      pieceQuantity: row.pieceQuantity ?? 0,
      price: Number(row?.price ?? 0),
      // siteId: row?.siteAllSku,
      extendedAttributes: {
        warehouseId: row?.warehouseAllSku,
        siteId: row?.siteAllSku
      },
      discountInfo: null,
      source: "DMS",
      supplier: supplier,
      type: "normal",
    };
  });

  const requestBody = {
    billAmount: sendAmount,
    netAmount: sendAmount,
    creationTime: getCurrentDateTimeFormat(),

    discountInfo: null,
    extendedAttributes: {
      isNewSchemes: true,
      isEditedFromPrimaryOms: true,
      tlc: oldTlc,
      ...(flagToConfirmOriginalOrder ? { siteId: fixSite, warehouseId: firstWarehouse } : {})
    },
    finalOrderInfo: {
      quantity: quantityNodes,
      finalAmount: sendAmount.toString(),
    },

    freeItemInfo: [],
    lineCount: orderDetailsNodes.length,
    loginId: loginid,
    orderDetails: orderDetailsNodes,
    outletCode: outletCode,
    referenceNumber: `${loginid}-${Date.now()}`,
    remarks: "",
    source: "DMS",
    status: flagToConfirmOriginalOrder ? "CONFIRMED" : "PENDING",
    submissionTime: getCurrentDateTimeFormat(),
    type: "primary",
  };

  return requestBody;
};

export const getCreateInvoicePopupMetaData = (hideCouponDiscount?: boolean) => {
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const { caseUnitLabel, otherUnitLabel, packUnitLabel } = ConfigDictionary;
  return [
    {
      key: "Total Number of Products",
      value: "totalProducts",
    },
    {
      key: `QTY(${caseUnitLabel?.toUpperCase() ?? ""})`,
      value: "csQty",
    },
    ...(packUnitLabel ?
      [{
      key: `QTY(${packUnitLabel?.toUpperCase() ?? ""})`,
      value: "pcQty",
      }] : []
    ),
    ...(otherUnitLabel
      ? [
          {
            key: `QTY(${otherUnitLabel?.toUpperCase() ?? ""})`,
            value: "otherQty",
          },
        ]
      : []),
    {
      key: "Total Amount (excl. Tax)",
      value: "totalAmount",
      currencySymbol: true,
    },
    {
      key: "Scheme Discount",
      value: "discountValue",
      currencySymbol: true,
    },
    ...(hideCouponDiscount ?
      [] :
      [{
      key: "Coupon Discount",
      value: "couponValue",
      currencySymbol: true,
      }]
    ),
    {
      key: "Final Bill Value",
      value: "netAmount",
      color: "#227C9D",
      currencySymbol: true,
    },
  ];
};

export const getCreateInvoiceSKUReplacementPopupMetaData = () => {
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const { caseUnitLabel, otherUnitLabel, packUnitLabel } = ConfigDictionary;
  return [
    {
      key: "Total Ordered Quantity",
      value: ["csQty","pcQty",...(otherUnitLabel ? ["otherQty"] : [])],
      multiQty: true
    },
    {
      key: "Total Amount (excl. Tax)",
      value: "totalAmount",
      currencySymbol: true,
    },
    {
      key: "Scheme Discount",
      value: "discountValue",
      currencySymbol: true,
    },
    {
      key: "Coupon Discount",
      value: "couponValue",
      currencySymbol: true,
    },
    {
      key: "Final Bill Value",
      value: "netAmount",
      color: "#227C9D",
      currencySymbol: true,
    },
  ];
};

export const getCreateInvoicePopupSKUReplacementMetaDataValues = (newOrderData: any) => {
  return {
    totalProducts: newOrderData?.lineCount,
    csQty: newOrderData?.totalCaseQuantity,
    pcQty: newOrderData?.totalPieceQuantity,
    otherQty: newOrderData?.totalOtherUnitQuantity,
    totalAmount: truncateToTwoDecimals(newOrderData?.totalAmount),
    discountValue: truncateToTwoDecimals(newOrderData?.discountValue),
    couponValue: truncateToTwoDecimals(newOrderData?.couponValue),
    netAmount: truncateToTwoDecimals(newOrderData?.netAmount),
  };
};

export const getCreateInvoicePopupMetaDataValues = (orderData: any) => {
  return {
    totalProducts: orderData?.lineCount,
    csQty: orderData?.totalCaseQuantity,
    pcQty: orderData?.totalPieceQuantity,
    otherQty: orderData?.totalOtherUnitQuantity,
    totalAmount: truncateToTwoDecimals(orderData?.totalAmount),
    discountValue: truncateToTwoDecimals(orderData?.discountValue),
    couponValue: truncateToTwoDecimals(orderData?.couponValue),
    netAmount: truncateToTwoDecimals(orderData?.netAmount),
  };
};

export const initialDiscountState = {
  discountApplied: false,
  discountValue: "",
  discountType: null,
};

export const getCreateInvoicePayload = (
  invoiceNumbers: string[],
  isEWayBill: boolean = false,
) => {
  const loggedInUserName = JSON.parse(localStorage.authContext || '{}')?.user?.loginId;

  const payload: any = {
    attributes: {
      name: isEWayBill ? "StandardEWayBill" : "StandardInvoice",
      format: "pdf",
      loggedInUserName,
      invoiceNumbers,
    },
    lob: getLob(),
  };

  return payload;
};

export const getCreateInvoicePayloadBulkInvoice = (
  invoiceNumbers: string[],
  isEWayBill: boolean = false,
) => {
  const loggedInUserName = JSON.parse(localStorage.authContext || '{}')?.user?.loginId;

  const payload: any = {
    attributes: {
      name: isEWayBill ? "StandardEWayBill" : "StandardInvoice",
      format: "pdf",
      loggedInUserName,
      invoiceNumbers,
    },
    lob: getLob(),
  };

  return payload;
};

export const createAndDownloadInvoicePdf = async (invoiceNumbers: string[], isEWayBill: boolean = false, calledFromBulkInvoice: boolean = false) => {
  const createInvoicePayload = calledFromBulkInvoice ? getCreateInvoicePayloadBulkInvoice(invoiceNumbers, isEWayBill) : getCreateInvoicePayload(invoiceNumbers, isEWayBill);

  const createInvoiceResponse = !isEWayBill ? await generateBatchInvoicePdf(createInvoicePayload) : await generateInvoicePdf(createInvoicePayload);
  const taskId = createInvoiceResponse?.data?.id;

  const blobKeys = await new Promise<any>((resolve, reject) => {
    const interval = setInterval(async () => {
      try {
        const downloadInvoicePdfResponse = await generateInvoicePdfFileKey(taskId);

        const status = downloadInvoicePdfResponse?.data?.features?.[0]?.status ?? "";
        const fileKeys = downloadInvoicePdfResponse?.data?.features?.[0]?.attributes?.fileKeys ?? []

        if (!isEWayBill) {
          if (status?.toLowerCase() === "success") {
            if (fileKeys?.[0] == "") {
              await sendSlackAlert(
                SlackChannel.DMS_SECONDARY_UI_NOTIFICATION,
                "Error generating pdf - ViewOrderUtils.ts",
                `Failed to generate pdf - createAndDownloadInvoicePdf()`,
                safeStringify({ invoiceNumbers,isEWayBill,createInvoicePayload,taskId ,createInvoiceResponse,downloadInvoicePdfResponse})
              );
              throw new Error();
            }
            resolve(fileKeys);
            clearInterval(interval);
          }
        } else {
          if (Array.isArray(fileKeys) && fileKeys?.length === invoiceNumbers?.length) {
            if (fileKeys?.every((key: string) => key?.toLocaleLowerCase()?.includes("fail")) || status === "FAILURE") {
              await sendSlackAlert(
                SlackChannel.DMS_SECONDARY_UI_NOTIFICATION,
                "Error generating pdf - ViewOrderUtils.ts",
                `Failed to generate pdf - createAndDownloadInvoicePdf()`,
                safeStringify({ invoiceNumbers,isEWayBill,createInvoicePayload,taskId,createInvoiceResponse,downloadInvoicePdfResponse })
              );
              throw new Error();
            }
            resolve(fileKeys);
            clearInterval(interval);
          }
        }

      } catch (err) {
        await sendSlackAlert(
          SlackChannel.DMS_SECONDARY_UI_NOTIFICATION,
          "Error generating pdf - ViewOrderUtils.ts",
          `Failed to generate pdf - createAndDownloadInvoicePdf()`,
          safeStringify({ invoiceNumbers,isEWayBill,createInvoicePayload,taskId,err ,createInvoiceResponse})
        );
        clearInterval(interval);
        reject(err);
        console.error(err);
      }
    }, 1000);
  });
  return blobKeys;
}



export const modifyCartToValidate = async (
  setCart: React.Dispatch<React.SetStateAction<Cart>>,
  orderData: any
) => {
  let modifiedCart = {};
  setCart((prevCart) => {
    const updatedCart = { ...prevCart };
    if (updatedCart[orderData?.outletCode]) {
      // filter out products with have case, piece and other unit quantities all set to 0
      const filteredProducts = Object.entries(updatedCart[orderData?.outletCode].productsMap)
        .filter(
          ([_, product]) =>
            product.caseQuantity > 0 || product.pieceQuantity > 0 || product.otherUnitQuantity > 0
        )
        .reduce((acc: any, [key, product]) => {
          acc[key] = product;
          return acc;
        }, {});
      updatedCart[orderData?.outletCode] = {
        productsMap: filteredProducts,
        customer: { outletCode: orderData?.outletCode, selectedSalesRep: orderData?.loginId },
      };
    }
    modifiedCart = updatedCart;
    return updatedCart;
  });
  await insertDataIntoLocalDB("Cart", [{ id: 1, data: modifiedCart }]);
  return modifiedCart;
};


export const getCokeNpInvoicePayload = (invoiceNumbers: string[]) => {
  return {
    attributes: {
      name: "CokeNPInvoice",
      format: "pdf",
      loggedInUserName: JSON.parse(localStorage.authContext)?.user?.loginId,
      invoiceNumbers: invoiceNumbers,
    },
    lob: getLob(),
  };
};

export const printBulkInvoicePdfCokeNp = async (invoiceNumbers: string[]) => {
  const createInvoicePayload = getCokeNpInvoicePayload(invoiceNumbers);

  const createInvoiceResponse = await generateBulkInvoicePdfCokeNp(createInvoicePayload);
  const taskId = createInvoiceResponse?.data?.id;

  const blobKeys = await new Promise<any>((resolve, reject) => {
    const interval = setInterval(async () => {
      try {
        const downloadInvoicePdfResponse = await generateInvoicePdfFileKey(taskId);

        const status = downloadInvoicePdfResponse?.data?.features?.[0]?.status ?? "";
        const fileKeys = downloadInvoicePdfResponse?.data?.features?.[0]?.attributes?.fileKeys ?? []

          if (status?.toLowerCase() === "success") {
            if (fileKeys?.[0] == "") {
              throw new Error();
            }
            resolve(fileKeys);
            clearInterval(interval);
          }

      } catch (err) {
        clearInterval(interval);
        reject(err);
        console.error(err);
      }
    }, 1000);
  });
  return blobKeys;
}

export const checkAllRowsHaveValidStock = (rows: viewManageOrderRowsData[], isEditing: boolean, disableStockCheck?: boolean) => {
  if(disableStockCheck) return true
  
  const result = rows?.every((item: viewManageOrderRowsData) => {
    const {
      caseQuantity,
      otherUnitQuantity,
      pieceQuantity,
      availableStock,
      initialCaseQuantity,
      initialOtherUnitQuantity,
      initialPieceQuantity,
      status,
      caseToPieceQty,
      otherToPieceQty,
    } = item;

    const orderStatusPending = status === "PENDING";

    if (!orderStatusPending && !isEditing) return true;

    const finalCaseStock = orderStatusPending
      ? availableStock?.cs
      : initialCaseQuantity + (isEditing ? availableStock?.cs : 0);
    const finalOtherStock = orderStatusPending
      ? availableStock?.other
      : initialOtherUnitQuantity + (isEditing ? availableStock?.other : 0);
    const finalPieceStock = orderStatusPending
      ? availableStock?.pc
      : initialPieceQuantity + (isEditing ? availableStock?.pc : 0);

    const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
    if (ConfigDictionary.uomConversion) {
      const normalizedQty =
        caseQuantity * caseToPieceQty + otherUnitQuantity * otherToPieceQty + pieceQuantity;
      const normalizedStock =
        finalCaseStock * caseToPieceQty + finalOtherStock * otherToPieceQty + finalPieceStock;
      return normalizedQty <= normalizedStock;
    }

    const isCaseQuantityValid = caseQuantity <= finalCaseStock;
    const isPieceQuantityValid = pieceQuantity <= finalPieceStock;
    const isOtherQuantityValid = otherUnitQuantity <= finalOtherStock;
    return isCaseQuantityValid && isPieceQuantityValid && isOtherQuantityValid;
  });

  return result;
};

export const checkAllRowsHaveValidMOQ = (rows: viewManageOrderRowsData[], isEditing: boolean, enableMOQCheck: boolean) => {
  if (!enableMOQCheck){
    return true
  }

  const result = rows?.every((item: viewManageOrderRowsData) => {
    const {
      caseQuantity,
      otherUnitQuantity,
      pieceQuantity,
      status,
      caseToPieceQty,
      otherToPieceQty,
      minimumOrderQuantity = 0,
    } = item;

    // const orderStatusPending = status === "PENDING";

    // if (!orderStatusPending) return true;
   
      const normalizedQty =
        caseQuantity * caseToPieceQty + otherUnitQuantity * otherToPieceQty + pieceQuantity;
      return normalizedQty >= minimumOrderQuantity;
  });

  return result;
};

export const countInvalidMOQRows = (
  rows: viewManageOrderRowsData[],
  enableMOQCheck: boolean
): number => {
  if (!enableMOQCheck) {
    return 0;
  }

  return rows?.filter((item: viewManageOrderRowsData) => {
    const {
      caseQuantity,
      otherUnitQuantity,
      pieceQuantity,
      caseToPieceQty,
      otherToPieceQty,
      minimumOrderQuantity = 0,
      freeItem
    } = item;
    if (freeItem) return false;
    const normalizedQty =
      caseQuantity * caseToPieceQty +
      otherUnitQuantity * otherToPieceQty +
      pieceQuantity;

    return normalizedQty < minimumOrderQuantity; // ❌ invalid MOQ
  }).length;
};

export const countInvalidStockRows = (
  rows: viewManageOrderRowsData[],
  isEditing: boolean,
  disableStockCheck?: boolean
): number => {
  if (disableStockCheck) return 0;

  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");

  return rows?.filter((item: viewManageOrderRowsData) => {
    const {
      caseQuantity,
      otherUnitQuantity,
      pieceQuantity,
      availableStock,
      initialCaseQuantity,
      initialOtherUnitQuantity,
      initialPieceQuantity,
      status,
      caseToPieceQty,
      otherToPieceQty,
      freeItem
    } = item;

    if (freeItem) return false;
    const orderStatusPending = status === "PENDING";

    if (!orderStatusPending && !isEditing) return false; // ✅ ignore

    const finalCaseStock = orderStatusPending
      ? availableStock?.cs
      : initialCaseQuantity + (isEditing ? availableStock?.cs : 0);
    const finalOtherStock = orderStatusPending
      ? availableStock?.other
      : initialOtherUnitQuantity + (isEditing ? availableStock?.other : 0);
    const finalPieceStock = orderStatusPending
      ? availableStock?.pc
      : initialPieceQuantity + (isEditing ? availableStock?.pc : 0);

    if (ConfigDictionary.uomConversion) {
      const normalizedQty =
        caseQuantity * caseToPieceQty +
        otherUnitQuantity * otherToPieceQty +
        pieceQuantity;

      const normalizedStock =
        finalCaseStock * caseToPieceQty +
        finalOtherStock * otherToPieceQty +
        finalPieceStock;

      return normalizedQty > normalizedStock; // ❌ invalid (exceeds stock)
    }

    // ❌ invalid if any UOM exceeds stock
    return (
      caseQuantity > finalCaseStock ||
      pieceQuantity > finalPieceStock ||
      otherUnitQuantity > finalOtherStock
    );
  }).length;
};


export const checkAllRowsToRemove = (rows: viewManageOrderRowsData[], isEditing: boolean, enableMOQCheck: boolean, disableStockCheck: boolean): string[] | false => {
  if (!enableMOQCheck || disableStockCheck) {
    return false;
  }

  const matchingBatchCodes = rows?.filter((item: viewManageOrderRowsData) => {
    const {
      caseQuantity,
      otherUnitQuantity,
      pieceQuantity,
      status,
      caseToPieceQty,
      otherToPieceQty,
      minimumOrderQuantity = 0,
      availableStock,
      initialCaseQuantity,
      initialOtherUnitQuantity,
      initialPieceQuantity,
    } = item;

    const orderStatusPending = status === "PENDING";

    const finalCaseStock = orderStatusPending
      ? availableStock?.cs
      : initialCaseQuantity + (isEditing ? availableStock?.cs : 0);

    const finalOtherStock = orderStatusPending
      ? availableStock?.other
      : initialOtherUnitQuantity + (isEditing ? availableStock?.other : 0);

    const finalPieceStock = orderStatusPending
      ? availableStock?.pc
      : initialPieceQuantity + (isEditing ? availableStock?.pc : 0);

    if (!orderStatusPending && !isEditing) return false;

    const normalizedQty =
      caseQuantity * caseToPieceQty +
      otherUnitQuantity * otherToPieceQty +
      pieceQuantity;

    const normalizedStock =
      finalCaseStock * caseToPieceQty +
      finalOtherStock * otherToPieceQty +
      finalPieceStock;

    return (normalizedStock < minimumOrderQuantity);
  }).map(item => item.batchCode);

  return matchingBatchCodes.length > 0 ? matchingBatchCodes : false;
};

export const prepareEditOrderReqBody = (
  orderValidateResponse: any,
  rows: viewManageOrderRowsData[]
) => {
  const filteredOrderValidateResponse: { [key: string]: any } = {};

  keysToKeep.forEach((key) => {
    if (orderValidateResponse.hasOwnProperty(key)) {
      filteredOrderValidateResponse[key] = orderValidateResponse[key];
      if (key === "orderDetails") {
        let orderDetailsFullNodes = filteredOrderValidateResponse[key];
        const filteredOrderDetailsArray: any = [];

        orderDetailsFullNodes.forEach((orderDetailsFullNode: any) => {
          const filteredOrderDetails: { [key: string]: any } = {};
          keysToKeepOD.forEach((odKey: any) => {
            if (orderDetailsFullNode.hasOwnProperty(odKey)) {
              filteredOrderDetails[odKey] = orderDetailsFullNode[odKey];
            }
          });
          filteredOrderDetailsArray.push(filteredOrderDetails);
        });

        filteredOrderValidateResponse[key] = filteredOrderDetailsArray;
      }
    }
  });

  orderValidateResponse = filteredOrderValidateResponse;

  orderValidateResponse["finalOrderInfo"] = {
    quantity: orderValidateResponse["orderDetails"].map((row: any) => {
      const { batchCode, caseQuantity, pieceQuantity, otherUnitQuantity } = row;
      return {
        batchCode: batchCode || "",
        caseQuantity: caseQuantity || 0,
        pieceQuantity: pieceQuantity || 0,
        otherUnitQuantity: otherUnitQuantity || 0,
      };
    }),
    finalAmount: orderValidateResponse?.billAmount,
  };

  delete orderValidateResponse["extendedAttributes"]["orderValidate"];

  orderValidateResponse["orderDetails"] = orderValidateResponse["orderDetails"]
    ?.map((obj: any) => {
      const targetRow = rows?.find((row: any) => row.batchCode === obj.batchCode);
      if (!targetRow || obj?.type == 'freeItem') return null;
      return {
        ...obj,
        caseQuantity: targetRow.caseQuantity,
        pieceQuantity: targetRow.pieceQuantity,
        otherUnitQuantity: targetRow.otherUnitQuantity,
      };
    })
    .filter(Boolean);

  return orderValidateResponse;
};

export const getBatchCodes = (orderDetails: any[] = []) => {
  const batchCodes: string[] = (orderDetails ?? [])?.map((order: any) => {
    return order?.batchCode;
  });
  const orderBatchCodesStringified: string = batchCodes?.join(",") ?? "";
  return orderBatchCodesStringified;
};

export const getBatchCodesWithoutFreeItem = (orderDetails: any[] = []): string => {
  const batchCodes: string[] = (orderDetails ?? [])
    .filter((order: any) => order?.type !== "freeItem") // Exclude freeItem
    .map((order: any) => order?.batchCode);

  const orderBatchCodesStringified: string = batchCodes.join(",") ?? "";
  return orderBatchCodesStringified;
};


export const createSkuWiseStockMapWithType = async (data: any, isPendingOrder:boolean, aggregatedStockMap?: Map<string, AggregatedStockData>) => {
  let updatedStockData: any = {};
  data?.forEach((obj: any) => {
    const { skuCode, type = "normal", caseQty, pieceQty, otherQty } = obj;
    let aggregatedSkuData: AggregatedStockData = aggregatedStockMap?.get(skuCode + '-' + type) ?? {
      type: type,
      batchCode: skuCode,
      caseQuantity: 0,
      pieceQuantity: 0,
      otherUnitQuantity: 0
    };
    updatedStockData[skuCode+'-'+type] = {
      availableCaseQty: adjustQty(
        (caseQty?.availableQty || aggregatedSkuData.caseQuantity) - aggregatedSkuData.caseQuantity,
        caseQty?.availableQty || aggregatedSkuData.caseQuantity,
        isPendingOrder
      ),
      availablePieceQty: adjustQty(
        (pieceQty?.availableQty || aggregatedSkuData.pieceQuantity) - aggregatedSkuData.pieceQuantity,
        pieceQty?.availableQty || aggregatedSkuData.pieceQuantity,
        isPendingOrder
      ),
      availableOtherQty: adjustQty(
        (otherQty?.availableQty || aggregatedSkuData.otherUnitQuantity) - aggregatedSkuData.otherUnitQuantity,
        otherQty?.availableQty || aggregatedSkuData.otherUnitQuantity,
        isPendingOrder
      ),
      actualAvailableCaseQty: caseQty?.availableQty,
      actualAvailablePieceQty: pieceQty?.availableQty,
      actualAvailableOtherQty: otherQty?.availableQty,
      committedCaseQty: caseQty?.committedQty,
      committedPieceQty: pieceQty?.committedQty,
      committedOtherQty: otherQty?.committedQty,
    };
  });
  return updatedStockData;
};

function adjustQty(calculatedQty: number, originalQty: number, isPendingOrder: boolean) {
  if (isPendingOrder) {
    // For pending orders: negative quantities become 0
    return calculatedQty < 0 ? 0 : calculatedQty;
  } else {
    // For non-pending: 0 or less become original availableQty
    return calculatedQty <= 0 ? originalQty : calculatedQty;
  }
}

export const createSkuWiseStockMap = async (data: any) => {
  let updatedStockData: any = {};
  data?.forEach((obj: any) => {
    const { skuCode, caseQty, pieceQty, otherQty } = obj;
    updatedStockData[skuCode] = {
      availableCaseQty: caseQty?.availableQty,
      availablePieceQty: pieceQty?.availableQty,
      availableOtherQty: otherQty?.availableQty,
      committedCaseQty: caseQty?.committedQty,
      committedPieceQty: pieceQty?.committedQty,
      committedOtherQty: otherQty?.committedQty,
    };
  });
  return updatedStockData;
};

export const createSkuWiseStockMapForBatchId = async (data: any[]) => {
  const updatedStockData: Record<
    string,
    {
      availableCaseQty: number;
      availablePieceQty: number;
      availableOtherQty: number;
      committedCaseQty: number;
      committedPieceQty: number;
      committedOtherQty: number;
    }
  > = {};

  data?.forEach((obj: any) => {
    const { skuCode, caseQty, pieceQty, otherQty } = obj;

    if (!updatedStockData[skuCode]) {
      // initialize if not exists
      updatedStockData[skuCode] = {
        availableCaseQty: 0,
        availablePieceQty: 0,
        availableOtherQty: 0,
        committedCaseQty: 0,
        committedPieceQty: 0,
        committedOtherQty: 0,
      };
    }

    updatedStockData[skuCode].availableCaseQty += caseQty?.availableQty ?? 0;
    updatedStockData[skuCode].availablePieceQty += pieceQty?.availableQty ?? 0;
    updatedStockData[skuCode].availableOtherQty += otherQty?.availableQty ?? 0;
    updatedStockData[skuCode].committedCaseQty += caseQty?.committedQty ?? 0;
    updatedStockData[skuCode].committedPieceQty += pieceQty?.committedQty ?? 0;
    updatedStockData[skuCode].committedOtherQty += otherQty?.committedQty ?? 0;
  });

  return updatedStockData;
};


export const getOrderTotalRowData = (
  data: any,
  ViewOrderEditTableHeader: any,
  ConfigDictionary: any = `{}`
) => {
  const { netAmount, totalCaseQuantity, totalPieceQuantity, totalOtherUnitQuantity } = data;

  return [
    {
      headerName: ViewOrderEditTableHeader?.FINALAMOUNT,
      total: `${truncateToTwoDecimals(netAmount) || netAmount}`,
      textAlign: "left",
      currencySymbol: true,
    },
    { headerName: "skuNameAndCode", total: "Total" },
    {
      headerName: ViewOrderEditTableHeader?.CASEQUANTITY,
      total: totalCaseQuantity,
      textAlign: "center",
    },
    ...(ConfigDictionary.otherUnitLabel
      ? [
          {
            headerName: ViewOrderEditTableHeader?.OTHERQUANTITY,
            total: totalOtherUnitQuantity,
            textAlign: "center",
          },
        ]
      : []),
    {
      headerName: ViewOrderEditTableHeader?.PIECEQUANTITY,
      total: totalPieceQuantity,
      textAlign: "center",
    },
  ];
};

export const checkForEmptyTable = (rows: viewManageOrderRowsData[]) => {
  const result = rows?.every((item) => {
    return item?.caseQuantity === 0 && item?.pieceQuantity === 0 && item?.otherUnitQuantity === 0;
  });
  return result;
};

export const ordersWithStockExceedingWarning = ["PENDING", "CONFIRMED", "INVOICED"];

export type GenericModal = {
  open: boolean;
  type: "positive" | "success" | "negative" | "error";
  message: string | any[];
  leftButtonText?: string;
  rightButtonText?: string;
  onLeftButtonClick?: () => void;
  onRightButtonClick?: () => void;
  leftButtonPadding?: string;
  confirmedOrders?: number;
  partiallyConfirmedOrders?: number;
  unavailableOrders?: number;
  width?: string;
};

export const initialGenericModalProps: GenericModal = {
  open: false,
  type: "positive",
  message: "",
};

export const getGenericModalProps = (
  type: "positive" | "success" | "negative" | "error",
  message: string | any[],
  leftButtonText?: string,
  rightButtonText?: string,
  onLeftButtonClick?: () => void,
  onRightButtonClick?: () => void,
  leftButtonPadding?: string,
  confirmedOrders?: number,
  partiallyConfirmedOrders?: number,
  unavailableOrders?: number,
  width?: string,
): GenericModal => {
  return {
    open: true,
    type,
    message,
    leftButtonText,
    rightButtonText,
    onLeftButtonClick,
    onRightButtonClick,
    leftButtonPadding,
    confirmedOrders,
    partiallyConfirmedOrders,
    unavailableOrders,
    width
  };
};

export const buttonLoading = (orderStatusChangeLoading: string, id: string): boolean => {
  if (orderStatusChangeLoading === id) return true;
  else return false;
};

export const customStyle = {
  width: 20,
  height: 20,
  color: "#fff",
};

export const transformedStatusForProgressCard = (status: string) => {
  switch (status) {
    case "PENDING":
      return "PENDING";
    case "CONFIRMED":
      return "CONFIRMED";
      case "PARTIALLY CONFIRMED":
      return "CONFIRMED";
    case "INVOICED":
      return "INVOICED";
    case "OUT FOR DELIVERY":
      return "INVOICED";
      case "DELIVERED":
      return "INVOICED";
    case "PARTIAL DELIVERED":
      return "INVOICED";
    default:
      return "REJECTED";
  }
}


export const transformedStatusForProgressCardV2 = (status: string) => {
  switch (status) {
    case "PENDING":
      return "PENDING";
    case "CONFIRMED":
      return "CONFIRMED";
      case "PARTIALLY CONFIRMED":
      return "CONFIRMED";
    case "INVOICED":
      return "INVOICED";
    case "PARTIALLY INVOICED":
      return "INVOICED";
    case "OUT FOR DELIVERY":
      return "OUT FOR DELIVERY";
      case "DELIVERED":
      return "DELIVERED";
    case "PARTIAL DELIVERED":
      return "DELIVERED";
    default:
      return "REJECTED";
  }
}

export const stages: Record<string, number> = { PENDING: 1, CONFIRMED: 2, INVOICED: 3, };

export const stagesV2: Record<string, number> = { PENDING: 1, INVOICED: 2, "OUT FOR DELIVERY": 3, DELIVERED: 4, };

export const showOverlayIn: string[] = [
  "REJECTED",
  "CONFIRMED",
  "ROWS",
  "STOCKS",
  "EDIT",
  "SAVE_CHANGES",
  "CANCELLED",
  "E_INVOICE",
  "E_WAY_BILL"
];

export const calculateFinalStock = (row: any) => {
  if (!row || typeof row !== "object") {
    throw new Error("Invalid input: row must be an object");
  }

  const { status, availableStock, initialPieceQuantity, initialCaseQuantity, initialOtherUnitQuantity } = row;

  if (!availableStock || typeof availableStock !== "object") {
    throw new Error("Invalid input: availableStock must be an object");
  }

  return {
    finalPieceStock:
      status === "PENDING"
        ? availableStock?.pc ?? 0
        : (availableStock?.pc ?? 0) + (initialPieceQuantity ?? 0),

    finalCaseStock:
      status === "PENDING"
        ? availableStock?.cs ?? 0
        : (availableStock?.cs ?? 0) + (initialCaseQuantity ?? 0),

    finalOtherStock:
      status === "PENDING"
        ? availableStock?.other ?? 0
        : (availableStock?.other ?? 0) + (initialOtherUnitQuantity ?? 0),
  };
};



export function checkIfNHoursPassed(creationTime: string, noOfHours: number): boolean {

  const isoString = creationTime.replace(" ", "T");

  const createdDate = new Date(isoString);

  if (isNaN(createdDate.getTime())) {
    return false;
  }

  const now = Date.now();
  const createdMs = createdDate.getTime();
  const diffMs = now - createdMs;

  const nHoursInMs = noOfHours * 60 * 60 * 1000;

  return diffMs >= nHoursInMs;
}

export const cancelEInvoiceAndEWayBillRejectionReasons: { [key: string]: string } = {
  "Duplicate IRN": "1",
  "Data Entry Mistake": "2",
  "Order Cancelled": "3",
  "Others": "4"
};
  
type StockData = {
  availableCaseQty?: number;
  availablePieceQty?: number;
  availableOtherQty?: number;
  committedCaseQty?: number;
  committedPieceQty?: number;
  committedOtherQty?: number;
};

export function combineTableRowsForCSO(
    tableRows: any[],
  ): viewManageOrderRowsData[] {
    const groupedRows = tableRows.reduce(
      (acc: Record<string, viewManageOrderRowsData[]>, row) => {
        if (row?.type === "freeItem") return acc;

        const { batchCode } = row;
        if (!acc[batchCode]) acc[batchCode] = [];
        acc[batchCode].push(row);

        return acc;
      },
      {}
    );

    return Object.keys(groupedRows).map((batchCode) => {
      const rowsForBatchCode = groupedRows[batchCode];

      if (rowsForBatchCode.length === 1) {
        return {
          ...rowsForBatchCode[0],
        };
      }

      const baseRow = rowsForBatchCode[0];

      const sumField = (field: keyof viewManageOrderRowsData) =>
        rowsForBatchCode.reduce((sum, row) => sum + (row[field] || 0), 0);

      return {
        ...baseRow,
        caseQuantity: sumField("caseQuantity"),
        pieceQuantity: sumField("pieceQuantity"),
        otherUnitQuantity: sumField("otherUnitQuantity"),
        initialCaseQuantity: sumField("initialCaseQuantity"),
        initialPieceQuantity: sumField("initialPieceQuantity"),
        initialOtherUnitQuantity: sumField("initialOtherUnitQuantity"),
        actualCaseQuantity: sumField("actualCaseQuantity"),
        actualPieceQuantity: sumField("actualPieceQuantity"),
        actualOtherUnitQuantity: sumField("actualOtherUnitQuantity"),
        initialNormalizedQuantity: sumField("initialNormalizedQuantity"),
      };
    });
  }

export function combineTableRowsWithStock(
  tableRows: viewManageOrderRowsData[],
  stocksData: Record<string, StockData>,
  withType?: boolean
): viewManageOrderRowsData[] {
  // Separate freeItems upfront
  const freeItemRows: viewManageOrderRowsData[] = tableRows.filter((row) => row?.freeItem);
  const nonFreeItemRows: viewManageOrderRowsData[] = tableRows.filter((row) => !row?.freeItem);

  // Group non-free items by batchCode
  const groupedRows = nonFreeItemRows.reduce(
    (acc: Record<string, viewManageOrderRowsData[]>, row) => {
      const { batchCode } = row;
      if (!acc[batchCode]) acc[batchCode] = [];
      acc[batchCode].push(row);
      return acc;
    },
    {}
  );

  // Merge grouped rows
  const mergedRows = Object.keys(groupedRows).map((batchCode) => {
    const rowsForBatchCode = groupedRows[batchCode];
    const skuStock = stocksData?.[withType ? (batchCode + "-normal") : batchCode] || {};

    const {
      availableCaseQty = 0,
      availablePieceQty = 0,
      availableOtherQty = 0,
      committedCaseQty = 0,
      committedPieceQty = 0,
      committedOtherQty = 0,
    } = skuStock;

    const availableStock = {
      cs: availableCaseQty,
      pc: availablePieceQty,
      other: availableOtherQty,
      csComitted: committedCaseQty,
      pcComitted: committedPieceQty,
      otherComitted: committedOtherQty,
    };

    if (rowsForBatchCode.length === 1) {
      return {
        ...rowsForBatchCode[0],
        availableStock,
        mergedRows: [...rowsForBatchCode],
        containsMultipleBatchId: rowsForBatchCode.length > 1,
        showMultipleRows: rowsForBatchCode.length > 1,
      };
    }

    const baseRow = rowsForBatchCode[0];

    const sumField = (field: keyof viewManageOrderRowsData) =>
      rowsForBatchCode.reduce((sum, row) => sum + (row[field] || 0), 0);

    const sumFloatField = (field: keyof viewManageOrderRowsData) =>
      rowsForBatchCode.reduce((sum, row) => sum + (parseFloat(row[field] as string) || 0), 0);
    const consolidatedTaxInfo = rowsForBatchCode
      .flatMap((row) => row.taxInfo || [])
      .reduce((acc: any[], t) => {
        const existing = acc.find((e) => e.taxType === t.taxType);
        if (existing) {
          existing.taxAmount += Number(t.taxAmount || 0);
        } else {
          acc.push({
            taxType: t.taxType,
            taxAmount: Number(t.taxAmount || 0),
            taxPercent: Number(t.taxPercent || 0),
          });
        }
        return acc;
      }, []);

    // Consolidate skuDiscountInfo
    const consolidatedDiscountInfo = rowsForBatchCode
      .flatMap((row) => row.skuDiscountInfo || [])
      .reduce((acc: any[], d) => {
        const existing = acc.find((e) => e.discountType === d.discountType);
        if (existing) {
          existing.discountAmount += Number(d.discountAmount || 0);
        } else {
          acc.push({
            discountType: d.discountType,
            discountAmount: Number(d.discountAmount || 0),
          });
        }
        return acc;
      }, []);

    return {
      ...baseRow,
      caseQuantity: sumField("caseQuantity"),
      pieceQuantity: sumField("pieceQuantity"),
      otherUnitQuantity: sumField("otherUnitQuantity"),
      initialCaseQuantity: sumField("initialCaseQuantity"),
      initialPieceQuantity: sumField("initialPieceQuantity"),
      initialOtherUnitQuantity: sumField("initialOtherUnitQuantity"),
      actualCaseQuantity: sumField("actualCaseQuantity"),
      actualPieceQuantity: sumField("actualPieceQuantity"),
      actualOtherUnitQuantity: sumField("actualOtherUnitQuantity"),
      actualAmount: sumFloatField("actualAmount").toString(),
      finalAmount: sumFloatField("finalAmount").toString(),
      initialNormalizedQuantity: sumField("initialNormalizedQuantity"),
      taxInfo: consolidatedTaxInfo,
      skuDiscountInfo: consolidatedDiscountInfo,
      availableStock,
      mergedRows: [...rowsForBatchCode],
      containsMultipleBatchId: rowsForBatchCode.length > 1,
      showMultipleRows: rowsForBatchCode.length > 1,
    };
  });

  return [...mergedRows, ...freeItemRows];
}


export const getSkuToReplacementSkuMap = async (skuList: string[]) => {

  const data = await getSkuReplacement(skuList)

  let skuToReplacementSkuMap: Record<string, string[]> = {}

  skuList.forEach((orderedSku: string) => {
    const replacements = data
      .filter((item: any) => item.entityId === orderedSku && item.parentId) // exclude nulls here too
      .map((item: any) => item.parentId as string)

    skuToReplacementSkuMap[orderedSku] = Array.from(new Set(replacements)) // unique per SKU
  })

  const distinctReplacementSku = Array.from(
    new Set(
      data
        .map((item: any) => item.parentId)
        .filter((id: string | null | undefined): id is string => !!id) // remove null/undefined
    )
  )

  return {
    skuToReplacementSkuMap,
    replacementSkuList: distinctReplacementSku,
  }
}

export function processSkuFulfillmentWithProduct(
  finalSkuMap: Map<string, number>,
  stockExceedingSkuMap: Map<string, number>,
  skuToReplacementSkuMap: Record<string, string[]>,
  tempNormalizedStockMap: Map<string, number>,
  products: any
) : {
    originalSkuFulfillmentMap: Map<string, FulfillmentInfo>;
    newReplacementSkuMap: Map<string, number>;
    skuNameMap: Map<string, string>;
  } {
    const originalSkuFulfillmentMap = new Map<string, FulfillmentInfo>();
    const newReplacementSkuMap = new Map<string, number>();
    const skuNameMap = new Map<string, string>();

    // helper to set name if product exists
    const setNameIfAvailable = (sku: string) => {
      if (!skuNameMap.has(sku)) {
        const p = products[sku]
        skuNameMap.set(sku, p?.name ?? sku);
      }
    };

    // Step 1: initialize with self-fulfillment
    finalSkuMap.forEach((fulfilledQty, originalSku) => {
      originalSkuFulfillmentMap.set(originalSku, {
        selfQty: fulfilledQty,
        replacements: new Map<string, number>(),
        unfulfilled: 0,
      });
      setNameIfAvailable(originalSku);
    });

    // Step 2: distribute excess into replacements (quantities only)
    stockExceedingSkuMap.forEach((excessQty, originalSku) => {
      const currentSkuReplacements = skuToReplacementSkuMap[originalSku] ?? [];
      let remainingExcess = excessQty;

      // ensure original has an entry (if not present in finalSkuMap)
      let info = originalSkuFulfillmentMap.get(originalSku);
      if (!info) {
        info = { selfQty: 0, replacements: new Map(), unfulfilled: 0 };
        originalSkuFulfillmentMap.set(originalSku, info);
        setNameIfAvailable(originalSku);
      }

      for (const replSku of currentSkuReplacements) {
        let replStock = tempNormalizedStockMap.get(replSku) ?? 0;
        if (replStock <= 0) continue;

        const fulfilled = Math.min(remainingExcess, replStock);
        if (fulfilled > 0) {
          // quantities only (matches FulfillmentInfo)
          info.replacements.set(replSku, (info.replacements.get(replSku) ?? 0) + fulfilled);

          // global replacement totals
          newReplacementSkuMap.set(replSku, (newReplacementSkuMap.get(replSku) ?? 0) + fulfilled);

          // record names separately
          setNameIfAvailable(replSku);

          // consume stock
          tempNormalizedStockMap.set(replSku, replStock - fulfilled);
          remainingExcess -= fulfilled;
        }
        if (remainingExcess <= 0) break;
      }

      info.unfulfilled = remainingExcess;
      originalSkuFulfillmentMap.set(originalSku, info);
    });

    return { originalSkuFulfillmentMap, newReplacementSkuMap, skuNameMap };
  }


export  function processSkuFulfillment(
    finalSkuMap: Map<string, number>,
    stockExceedingSkuMap: Map<string, number>,
    skuToReplacementSkuMap: Record<string, string[]>,
    tempNormalizedStockMap: Map<string, number>,
    products: Catalogue[]
  ): {
    originalSkuFulfillmentMap: Map<string, FulfillmentInfo>;
    newReplacementSkuMap: Map<string, number>;
    skuNameMap: Map<string, string>;
    hasUnfulfilled: boolean
  } {
    const originalSkuFulfillmentMap = new Map<string, FulfillmentInfo>();
    const newReplacementSkuMap = new Map<string, number>();
    const skuNameMap = new Map<string, string>();
    let hasUnfulfilled = false;
    // helper to set name if product exists
    const setNameIfAvailable = (sku: string) => {
      if (!skuNameMap.has(sku)) {
        const p = createCartProductFromCatalogue(products, sku)
        skuNameMap.set(sku, p?.name ?? sku);
      }
    };

    // Step 1: initialize with self-fulfillment
    finalSkuMap.forEach((fulfilledQty, originalSku) => {
      originalSkuFulfillmentMap.set(originalSku, {
        selfQty: fulfilledQty,
        replacements: new Map<string, number>(),
        unfulfilled: 0,
      });
      setNameIfAvailable(originalSku);
    });

    // Step 2: distribute excess into replacements (quantities only)
    stockExceedingSkuMap.forEach((excessQty, originalSku) => {
      const currentSkuReplacements = skuToReplacementSkuMap[originalSku] ?? [];
      let remainingExcess = excessQty;

      // ensure original has an entry (if not present in finalSkuMap)
      let info = originalSkuFulfillmentMap.get(originalSku);
      if (!info) {
        info = { selfQty: 0, replacements: new Map(), unfulfilled: 0 };
        originalSkuFulfillmentMap.set(originalSku, info);
        setNameIfAvailable(originalSku);
      }

      for (const replSku of currentSkuReplacements) {
        let replStock = tempNormalizedStockMap.get(replSku) ?? 0;
        if (replStock <= 0) continue;

        const fulfilled = Math.min(remainingExcess, replStock);
        if (fulfilled > 0) {
          // quantities only (matches FulfillmentInfo)
          info.replacements.set(replSku, (info.replacements.get(replSku) ?? 0) + fulfilled);

          // global replacement totals
          newReplacementSkuMap.set(replSku, (newReplacementSkuMap.get(replSku) ?? 0) + fulfilled);

          // record names separately
          setNameIfAvailable(replSku);

          // consume stock
          tempNormalizedStockMap.set(replSku, replStock - fulfilled);
          remainingExcess -= fulfilled;
        }
        if (remainingExcess <= 0) break;
      }
      if (remainingExcess > 0) {
        hasUnfulfilled = true;
      }
      info.unfulfilled = remainingExcess;
      originalSkuFulfillmentMap.set(originalSku, info);
    });

    return { originalSkuFulfillmentMap, newReplacementSkuMap, skuNameMap, hasUnfulfilled };
  }

export function getSkuToMinExpiryDate(stocksData: any[]) {
  const skuToMinExpiryDateMap: Record<string, Date> = {};

  stocksData?.forEach((obj: any) => {
    const { skuCode, caseQty, pieceQty, otherQty } = obj;

    let expiryDate = caseQty?.expiryDate ?? pieceQty?.expiryDate ?? otherQty?.expiryDate;

    if (expiryDate) {
      const parsedDate = new Date(expiryDate.replace(" ", "T"));

      if (!skuToMinExpiryDateMap[skuCode]) {
        skuToMinExpiryDateMap[skuCode] = parsedDate;
      } else {
        skuToMinExpiryDateMap[skuCode] =
          parsedDate.getTime() < skuToMinExpiryDateMap[skuCode].getTime()
            ? parsedDate
            : skuToMinExpiryDateMap[skuCode];
      }
    }
  });

  return skuToMinExpiryDateMap;
}

export interface SkuExpiryInfo {
  minExpiryDate: Date;
  batchId: string;
}

export function getSkuToMinExpiryBatch(stocksData: any[]): Record<string, SkuExpiryInfo> {
  const skuToMinExpiryMap: Record<string, SkuExpiryInfo> = {};

  stocksData?.forEach((obj: any) => {
    const { skuCode, batchId, caseQty, pieceQty, otherQty } = obj;

    // Determine expiry date from available units
    const avCsQty = caseQty?.availableQty ?? 0
    const avPcQty = pieceQty?.availableQty ?? 0
    const avOthQty= otherQty?.availableQty ?? 0
    let expiryDateStr = caseQty?.expiryDate ?? pieceQty?.expiryDate ?? otherQty?.expiryDate;
    if (avCsQty === 0 && avPcQty === 0 && avOthQty === 0) return
    if (!expiryDateStr) return;

    const parsedDate = new Date(expiryDateStr.replace(" ", "T"));

    if (!skuToMinExpiryMap[skuCode] || parsedDate.getTime() < skuToMinExpiryMap[skuCode].minExpiryDate.getTime()) {
      skuToMinExpiryMap[skuCode] = {
        minExpiryDate: parsedDate,
        batchId: batchId
      };
    }
  });

  return skuToMinExpiryMap;
}

interface SkuNameCode {
  skuName: string;
  skuCode: string;
}

export function getSkuToNameCodeMap(
  products: Record<string, any>,
  batchCodes: string[]
): Record<string, SkuNameCode> {
  const result: Record<string, SkuNameCode> = {};

  batchCodes.forEach((batchCode) => {
    const product = products[batchCode];
    if (product) {
      result[batchCode] = {
        skuName: product.skuDescription ?? "",
        skuCode: product.skuCode ?? "",
      };
    } else {
      console.warn(`No product found for batchCode: ${batchCode}`);
    }
  });

  return result;
}




export  const getBatchCodeQuantities = (batchCodes: string, batchCodeMap: any): Map<string, [number, number, number]> => {
  let batchCodesArray: string[] = batchCodes ? batchCodes.split(",") : [];
  const result = new Map<string, [number, number, number]>();
  
  batchCodesArray.forEach((bc) => {
      const skuStock = batchCodeMap?.[bc];
      if (!skuStock) {
          // If the batch code doesn't exist in the map, set all quantities to 0
          result.set(bc, [0, 0, 0]);
          return;
      }
      
      let {
          availableCaseQty = 0,
          availablePieceQty = 0,
          availableOtherQty = 0,
          committedCaseQty = 0,
          committedPieceQty = 0,
          committedOtherQty = 0,
      } = skuStock;
      
      let availableStock = {
          cs: availableCaseQty,
          pc: availablePieceQty,
          other: availableOtherQty,
          csComitted: committedCaseQty,
          pcComitted: committedPieceQty,
          otherComitted: committedOtherQty,
      };
      
      // Store the quantities for this batch code in the map
      result.set(bc, [availableStock.cs, availableStock.pc, availableStock.other]);
  });
  
  return result;
};

export const getOrderSummaryFromAllocation = (
    uomWiseAllocationMap: Map<
      string,
      { caseQty: number; pieceQty: number; otherUnitQty: number }
    >,
    catalogue: Catalogue[]
  ) => {
    let totalProducts = 0;
    let totalCaseQuantity = 0;
    let totalPieceQuantity = 0;
    let totalOtherUnitQuantity = 0;
    let totalAmount = 0;
    let discountValue = 0; // placeholder
    let couponValue = 0; // placeholder
    const summaryProducts: any[] = [];
    uomWiseAllocationMap.forEach((value, sku) => {
      const { caseQty, pieceQty, otherUnitQty } = value;
      if (caseQty + pieceQty + otherUnitQty === 0) return;
      
      const catalogueProduct = createCartProductFromCatalogue(catalogue, sku);

      totalProducts += 1;
      totalCaseQuantity += caseQty;
      totalPieceQuantity += pieceQty;
      totalOtherUnitQuantity += otherUnitQty;

      if (!catalogueProduct) return;

      const { price, casePrice, otherUnitPrice } = catalogueProduct;
      const actualAmount =
        caseQty * Number(casePrice ?? 0) +
        otherUnitQty * Number(otherUnitPrice ?? 0) +
        pieceQty * Number(price ?? 0);

      totalAmount += actualAmount;

      summaryProducts.push({
        batchCode: catalogueProduct.batchCode,
        skuCode: sku,
        caseQuantity: caseQty,
        pieceQuantity: pieceQty,
        otherUnitQuantity: otherUnitQty,
        finalAmount: actualAmount,
        price: price,
        casePrice: casePrice,
        otherUnitPrice: otherUnitPrice,
      });
    });

    const netAmount = totalAmount - discountValue - couponValue;

    return {
      summary: {
        totalProducts,
        totalCaseQuantity,
        totalPieceQuantity,
        totalOtherUnitQuantity,
        totalAmount,
        discountValue,
        couponValue,
        netAmount,
      },
      products: summaryProducts,
    };
  };
